exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/dev-man/Kgwetlwo-app/src/app/pages/company/mission/mission.component.css
// module id = ../../../../../src/app/pages/company/mission/mission.component.css
// module chunks = main